import {
	FormControl,
	Grid,
	InputLabel,
	Menu,
	MenuItem,
	Select,
	TableCell,
	TableRow,
	TextField,
	Tooltip,
} from '@material-ui/core';
import { Email, Phone, CheckCircle } from '@material-ui/icons';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { getDateDocCreated } from './clientsUtils/getDateDocCreated';
import { getLastDocCreatedInfo } from './clientsUtils/getLastDocCreatedInfo';
import styles from './PurchasesItem.module.scss';
import {
	createTheme,
	ThemeProvider,
	withStyles,
} from '@material-ui/core/styles';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { connect } from 'react-redux';
import { assignSalesAgent } from '../../../api/Deals/assignSalesAgent.api';
import ClientDetailsModal from './ClientDetailsModal/ClientDetailsModal';
import CopyToClipboard from 'react-copy-to-clipboard';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import getContractStatus from '../../../api/Purchasers/getContractStatus.api';
import { IconButton, ListItemText, Popover, Popper } from '@mui/material';
import getCoolingPeriodTime from '../../../api/Purchasers/getCoolingPeriodTime.api';
import {
	closeConfirmation,
	setConfirmation,
} from '../../../redux/confirmations/actions';
import ConfirmationComponent from '../../confirmation/ConfirmationComponent';
import { useDropdownStyle } from '../../../muiStyles/Dropdown.mui';
import { ReactComponent as CoBrokerIcon } from '../../../assets/icons/cobroker.svg';
import getUserById from '../../../api/Purchasers/getUserById';
import checkSalesAgentCoBroker from '../../../api/Purchasers/checkSalesAgentCoBroker.api';
import { setLoading } from '../../../redux/purchasers/actions';
import { checkRolesAccessibilities } from '../../../utils/checkRolesAccessibilities';

const PurchasesItem = ({
	client,
	index,
	salesAgents,
	assignSalesAgentsDropdown,
	setAssignSalesAgentsDropdown,
	handleOpenClientDetails,
	anchorEl,
	setAnchorEl,
	handleClose,
	showManage,
	setTemporaryIdForDropdown,
	handleClickManage,
	agreements,
	setConfirmation,
	closeConfirmation,
	confirmation,
	userType,
	coBrokers,
	setLoading,
	rolesAccessibilities,
}) => {
	const [contractStatus, setContractStatus] = useState();
	const [anchorElContact, setAnchorElContact] = useState();
	const [contactType, setContactType] = useState('');
	const [contactId, setContactId] = useState('');
	const [agreementObj, setAgreementObj] = useState();
	const [cobrokerName, setCobrokerName] = useState();
	const [verificationStatus, setVerificationStatus] = useState();

	useEffect(() => {
		console.log('PurchasesItem agreements', agreements);
		if (agreements.length > 0) {
			var agreementObject =
				agreements &&
				agreements?.find((item) => item.leadsKey === client.leadId);
		}

		setAgreementObj(agreementObject);
	}, [agreements, client]);

	useEffect(() => {
		if (agreementObj?.clientInfo?.individual) {
			let status =
				agreementObj?.clientInfo?.individual[
					Object.keys(agreementObj.clientInfo.individual).shift()
				]?.identification?.verification?.status || null;
			setVerificationStatus(status);
		}
		agreementObj &&
			getContractStatus(
				{
					leadId: client.leadId,
				},
				(returned) => {
					setContractStatus(returned);
				}
			);
	}, [agreementObj]);

	const handleChange = (e, clientId, salesAgentPointer, isCobroker) => {
		setAssignSalesAgentsDropdown({
			...assignSalesAgentsDropdown,
			[clientId]: e.target.value,
		});

		setLoading(true);

		assignSalesAgent(
			client.leadToSalesAgent,
			client.leadId,
			e.target.value,
			isCobroker,
			(returned) => {
				setLoading(false);
			}
		);
	};

	var dateDocCreated = getDateDocCreated(client);

	var lastDocInfo = getLastDocCreatedInfo(client);

	// console.log('PurchasesItem agreementObj', agreementObj);
	const styleShow = (index) => {
		console.log('styleShow', Number(showManage), Number(index));
		if (Number(showManage) === Number(index)) {
			return { display: 'block' };
		} else {
			return { display: 'none' };
		}
	};

	useEffect(() => {
		client &&
			getUserById(client?.cobroker).then((returned) => {
				setCobrokerName(returned?.displayName);
			});
	}, [client]);

	// console.log('contractStatus?.name', contractStatus);

	const handleClickContactBtn = (event) => {
		setAnchorElContact(event.currentTarget);
		setContactType(event.currentTarget.dataset.contact);
		setContactId(event.currentTarget.dataset.id);
	};

	const handleCloseContactPopover = () => {
		setAnchorElContact(null);
		setContactType('');
		setContactId('');
	};

	const handleDeletePurchaser = () => {
		setConfirmation('deletePurchaser');
		setAnchorEl(null);
	};

	const open = Boolean(anchorElContact);

	const classes = useDropdownStyle();

	const checkCoBrokerSalesAgentRelationship = (salesAgentId, coBrokerId) => {
		var check;
		checkSalesAgentCoBroker(salesAgentId, coBrokerId, (returned) => {
			console.log('siofgsfsf', returned);
			check = returned;
		});

		console.log('sfjwssof', check);
		return check;
	};

	const getCoBrokersSalesAgent = (cobrokerId) => {
		let foundSalesAgentObj = coBrokers.find(
			(item) => item.userId === cobrokerId
		);

		console.log('foundSalesAgentObj', foundSalesAgentObj, cobrokerId);
		return foundSalesAgentObj;
	};

	return (
		<>
			<TableRow hover={true}>
				<TableCell>
					{agreementObj?.productAvailability?.lotId
						? agreementObj?.productAvailability?.lotId
						: '---'}
				</TableCell>
				<TableCell
					className={styles.nameColumn}
					onClick={() => {
						handleOpenClientDetails(client.leadId);
					}}
				>
					<div className={styles.nameWrapper}>
						{`${client?.clientFName} ${client?.clientLName} `}
						{(verificationStatus === 'verified' ||
							verificationStatus === 'manually_verified') && (
							<div className={styles.checkmarkWrapper}>
								<CheckCircle
									className={styles.verifiedChecker}
								/>
							</div>
						)}
						{client?.cobroker && userType !== 'cobroker' && (
							<div className={styles.cobrokerIconWrapper}>
								<CoBrokerIcon />
							</div>
						)}
					</div>
				</TableCell>
				<TableCell>
					{dayjs(client?.createTimestamp).format('DD MMM YYYY')}
				</TableCell>
				<TableCell>
					<div
						className={styles.documentation_item}
						style={{
							backgroundColor: contractStatus?.backgroundColor,
							color: contractStatus?.color,
						}}
					>
						{contractStatus?.name}{' '}
					</div>
				</TableCell>
				{checkRolesAccessibilities(
					rolesAccessibilities,
					userType,
					'deals',
					'purchasers',
					0
				) && (
					<TableCell>
						<FormControl
							style={{ display: 'flex', flexDirection: 'column' }}
						>
							<TextField
								key={client?.leadId}
								style={{
									borderRadius: '4px',
									minWidth: '200px',
									width: '200px',
									boxSizing: 'border-box',
									border: '0.1px solid #e0e0e0',
								}}
								variant='outlined'
								name={client?.leadId}
								value={
									assignSalesAgentsDropdown[client?.leadId] ||
									getCoBrokersSalesAgent(client?.cobroker)
										?.assignedSalesAgent ||
									client.leadToSalesAgent
								}
								className={styles.textField}
								onChange={(e) =>
									handleChange(
										e,
										client?.leadId,
										client?.salesAgentPointer,
										client?.cobroker
									)
								}
								select
								SelectProps={{
									style: {
										backgroundColor: 'none',
										color: 'var(--primary-hover)',
										fontWeight: 'bold',
										height: '42px',
									},

									name: client.leadId,

									MenuProps: {
										MenuListProps: {
											disablePadding: true,
											disablePortal: true,
										},
									},
								}}
								defaultValue={
									client.leadToSalesAgent
										? client.leadToSalesAgent
										: 'Select Agent'
								}
							>
								<MenuItem
									classes={{
										selected: classes.menuItemSelected,
										root: classes.root,
									}}
									value='Select Agent'
								>
									Select Agent
								</MenuItem>
								{salesAgents?.map((salesAgent, index) => (
									<MenuItem
										value={salesAgent.salesAgentId}
										classes={{
											selected: classes.menuItemSelected,
											root: classes.root,
										}}
										className={styles.menuItemClass}
										key={index}
									>
										{/* <div className={styles.salesAgentName}> */}
										{salesAgent.salesAgentName}
										{/* </div> */}

										{/* {client?.cobroker &&
											checkCoBrokerSalesAgentRelationship(
												salesAgent.salesAgentId,
												client?.cobroker
											) === true && (
												<div
													className={
														styles.coBrokerNameSelect
													}
												>
													{cobrokerName} (Co-Broker)
												</div>
											)} */}
									</MenuItem>
								))}
								{/* {coBrokers?.map((cobroker) => (
									<MenuItem
										value={cobroker.userId}
										classes={{
											selected: classes.menuItemSelected,
											root: classes.root,
										}}
									>
										{cobroker.name}
									</MenuItem>
								))} */}
							</TextField>
						</FormControl>
						{cobrokerName && (
							<div className={styles.cobrokerName}>
								{cobrokerName} (Co-Broker)
							</div>
						)}
					</TableCell>
				)}

				<TableCell className={styles.contact_group}>
					<Tooltip title={'Email'}>
						<IconButton
							onClick={handleClickContactBtn}
							data-contact='email'
							data-id={client?.leadId}
						>
							<Email className={styles.contact_btn} />
						</IconButton>
					</Tooltip>
					<Tooltip title={'Phone Number'}>
						<IconButton
							onClick={handleClickContactBtn}
							data-contact='phone'
							data-id={client?.leadId}
						>
							<Phone className={styles.contact_btn} />
						</IconButton>
					</Tooltip>
					<Popover
						open={open && contactId === client?.leadId}
						anchorEl={anchorElContact}
						onClose={handleCloseContactPopover}
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'center',
						}}
						transformOrigin={{
							vertical: 'top',
							horizontal: 'center',
						}}
						disableScrollLock
					>
						<div className={styles.contact_popover}>
							<p>
								{contactType === 'phone'
									? client.clientPhoneNumber
									: contactType === 'email'
									? client.clientEmail
									: ''}
							</p>
							<CopyToClipboard
								text={
									contactType === 'phone'
										? client.clientPhoneNumber
										: contactType === 'email'
										? client.clientEmail
										: ''
								}
								onCopy={handleCloseContactPopover}
								className={styles.copy_btn}
							>
								<Tooltip title={'Copy'}>
									<FileCopyIcon />
								</Tooltip>
							</CopyToClipboard>
						</div>
					</Popover>
				</TableCell>
				<TableCell>
					<Grid item className={styles.manageGroup}>
						<div
							aria-controls={`simple-menu${index}`}
							aria-haspopup='true'
							data-leadtosalesagent={client.leadToSalesAgent}
							data-leadId={client.leadId}
							data-lotid={
								agreementObj?.productAvailability?.lotId
							}
							data-manageid={index}
							onClick={(e) => {
								handleClickManage(e);
								setTemporaryIdForDropdown(client.keyValue);
							}}
						>
							<Tooltip title={'Other Actions'}>
								<MoreVertIcon className={styles.actionBtn} />
							</Tooltip>
						</div>

						<Menu
							id={`simple-menu${index}`}
							anchorEl={anchorEl}
							keepMounted
							open={Boolean(anchorEl)}
							onClose={handleClose}
							className={styles.manageDropdown}
							style={{ ...styleShow(index) }}
							MenuListProps={{ disablePadding: true }}
							PaperProps={{
								style: {
									boxShadow: '0px 1px 9px rgba(0, 0, 0, 0.1)',
									width: '173px',
								},
							}}
						>
							<MenuItem
								className={styles.dropdownItem}
								onClick={(e) => handleDeletePurchaser()}
							>
								Delete
							</MenuItem>
						</Menu>
					</Grid>
				</TableCell>
			</TableRow>
		</>
	);
};

const mapStateToProps = (state) => ({
	confirmation: state.confirmation,
	userType: state.signIn.userType,
	coBrokers: state.siteplanManagement.coBrokers,
	rolesAccessibilities: state.userManagement.rolesAccessibilities,
});

export default connect(mapStateToProps, {
	setConfirmation,
	closeConfirmation,
	setLoading,
})(PurchasesItem);
